import * as classNames from "classnames";
import * as React from 'react';
import Expandable from '../../common/Expandable';
import ScanChart from '../ScanChart';


type TypeSummaryProps = {
    className: any,
    colors: any,
    data: any,
    defaultClosed: any,
    displayIcon: any,
    displayUsers: any,
    questionData: any,
    title: any
};

type TypeSummaryActions = {

};

type TypeSummaryPropsAndActions = TypeSummaryProps & TypeSummaryActions;

type TypeSummaryState = {
    showChart: boolean
};


class TypeSummary extends React.Component<TypeSummaryPropsAndActions, TypeSummaryState> {
    constructor(props, context) {
        super(props, context);
        this.state = { showChart: true };
        this.onToggleShowClicked = this.onToggleShowClicked.bind(this);
    }

    onToggleShowClicked() {
        this.setState({ showChart: !this.state.showChart });
    }

    render() {
        const { data, questionData, displayIcon, displayUsers } = this.props;
        let icon = data.length > 0 && displayIcon === true ? <img src={data[0].icon} width="30" /> : undefined;

        var users = data.map(d => { return d.user });
        let uniqueUsers = [...new Set(users)];
        let uData = uniqueUsers.map((s, i) => {

            var count = data.filter(i => i.user == s).length;
            return {
                label: s,
                count: count,
                perc: ((count / users.length) * 100).toFixed(2)
            }
        });
        uData.sort(function (a, b) { return b.count - a.count });


        var questions = questionData.map(d => { return d.question });
        let uniqueQuestions = [...new Set(questions)];
        let qData = uniqueQuestions.map((s, i) => {
            var count = questionData.filter(i => i.question == s).length;
            return {
                label: s,
                count: count,
                perc: ((count / questions.length) * 100).toFixed(2)
            }
        })
        qData.sort(function (a, b) { return b.count - a.count });

        var pieChartSize = uniqueQuestions.length < 5 || uniqueUsers.length < 5 ? "150px" : undefined;
        return (
            <div className={classNames("my-2", this.props.className)}>

                <Expandable
                    defaultClosed={this.props.defaultClosed}
                    title={this.props.title}
                    allowClose={false}
                    allowExpand={true}
                >
                    <div className="mx-2 my-2">
                        <div style={{ width: "100%" }}>
                            <div className="row no-gutters my-0 mx-2">
                                <div className={classNames("col-9")}>
                                    <div className="row no-gutters">
                                        <div className="col-6">
                                            <strong>Data</strong>
                                        </div>
                                        <div className="col-3 text-center"><strong>Count</strong></div>
                                        <div className="col-3 text-center"><strong>%</strong></div>
                                    </div>
                                    {
                                        qData.map((s, i) => {
                                            return <div key={i} className="row no-gutters content-data-line my-2">
                                                <div className="col-6">
                                                    {s.label}
                                                </div>
                                                <div className="col-3 text-center">{s.count}</div>
                                                <div className="col-3 text-center">{s.perc}%</div>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className={classNames("col-3")}>
                                    <div className="row no-gutters">
                                        <div className="col-12">
                                            <ScanChart
                                                chartType='PieChart'
                                                collate={true}
                                                colors={this.props.colors}
                                                data={questionData}
                                                defaultClosed={undefined}
                                                discrete={undefined}
                                                displayIcon={undefined}
                                                groupBy={['question']}
                                                height={pieChartSize}
                                                legend="none"
                                                title={undefined}
                                                width={pieChartSize}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {displayUsers ?
                                <div className="row no-gutters my-0 mx-2">
                                    <div className={classNames("col-9")}>
                                        <div className="row no-gutters">
                                            <div className="col-6">
                                                <strong>User</strong>
                                            </div>
                                            <div className="col-3 text-center"><strong>Count</strong></div>
                                            <div className="col-3 text-center"><strong>%</strong></div>
                                        </div>
                                        {
                                            uData.map((s, i) => {
                                                return <div key={i} className="row no-gutters content-data-line my-2">
                                                    <div className="col-6">
                                                        {s.label}
                                                    </div>
                                                    <div className="col-3 text-center">{s.count}</div>
                                                    <div className="col-3 text-center">{s.perc}%</div>
                                                </div>
                                            })
                                        }
                                    </div>
                                    <div className={classNames("col-3")}>
                                        <div className="row no-gutters">
                                            <div className="col-12">
                                                <ScanChart
                                                    chartType='PieChart'
                                                    collate={true}
                                                    colors={this.props.colors}
                                                    data={data}
                                                    defaultClosed={undefined}
                                                    discrete={undefined}
                                                    displayIcon={undefined}
                                                    groupBy={['user']}
                                                    height={pieChartSize}
                                                    legend="none"
                                                    title={undefined}
                                                    width={pieChartSize}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : undefined}
                        </div>

                    </div>
                </Expandable>
            </div>

        );
    }
}

export default TypeSummary;
